import { render, staticRenderFns } from "./movie-category-form.vue?vue&type=template&id=ca7aa6b0&"
import script from "./movie-category-form.vue?vue&type=script&lang=ts&"
export * from "./movie-category-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports